export const AVATAR_GRADIENTS: MotherAvatarDefault[] = [
	{ id: 'grad1', start: '#ed6b57', end: '#0d2a54', deg: '216deg' },
	{ id: 'grad2', start: '#0d2a54', end: '#9c69d2', deg: '138deg' },
	{ id: 'grad3', start: '#ed6b57', end: '#9c69d2', deg: '47deg' }
];

export interface MotherAvatarDefault {
	start?: string;
	end?: string;
	deg?: string;
	id?: string;
}

export interface Engagement {
	id?: string | null;
	agency_id?: string | null;
	chat_id?: string | null;
	invited?: boolean;
	sent?: boolean;
	sent_at?: any;
	counselor_id?: string | null;
	counselor_first_name?: string | null;
	counselor_last_name?: string | null;
	counselor_avatar?: string | null;
	counselor_avatar_thumb?: string | null;
	counselor_phone?: string | null;
	mother_id?: string | null;
	mother_first_name?: string | null;
	mother_last_name?: string | null;
	mother_email?: string | null;
	mother_phone?: string | null;
	mother_phone_formatted?: string | null;
	mother_avatar_thumb?: string | null;
	mother_avatar?: string | null;
	mother_avatar_default?: MotherAvatarDefault;
	mother_address?: string | null;
	module?: 'adoptionAdvocate' | 'optionsCoach';
	had_phone_conversation?: boolean;
	mother_location?: any;
	recommended_article_id?: string | null;
	recommended_article_name?: string | null;
	recommended_article_url?: string | null;
	location_tracked?: boolean;
	pregnancy_expected?: 'expected' | 'unexpected' | null;
	start_quiz_taken?: boolean;
	start_quiz_id?: string | null;
	onboarding_survey_taken?: boolean;
	onboarding_survey_id?: string | null;
	considering?: 'abortion' | 'adoption' | 'parent' | 'unsure' | 'referral' | null;
	decision?: 'abortion' | 'adoption' | 'parent' | 'unsure' | 'referral' | null;
	engagement_link?: string | null;
	current_session?: any;
	total_page_views?: number;
	source_domain?: string | null;
	source_name?: string | null;
	opt_flag?: 'STOP' | 'START';
	archived?: boolean;
	archived_at?: any;
	claimed?: boolean;
	engagement_deleted?: boolean;
	engagement_deleted_at?: any;
	initial_connect_family_id?: string | null;
	created_at?: any;
	created_at_unix?: number;
	claimed_at?: any;
	last_updated?: number;
	is_live?: boolean;
	last_live_at?: any;
	last_live_at_unix?: number;
	last_active_task_name?: string;
	num_prayers_received?: number;
}
